
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_SET_houseColorNumber } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden } from "../../reducers/uiReducer";

import moment from 'moment';

const ColorSettings: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const selectColor = (e: React.MouseEvent, colorNumber: number) => {
        e.preventDefault();
        dispatch(DEV_SET_houseColorNumber(colorNumber));
        //setSelectedColor(colorNumber);
    };

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
                boxSizing: "border-box",
                position: "relative",
               
                //backgroundColor: "orange",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                //flexDirection: "column",
            }}
        >

            <div
                style={{
                    width: "100%",
                    height: "auto",
                    display: "grid",
                    justifyContent: "center",
                    alignItems: "center",
                    gridTemplateColumns: 'repeat(8, 1fr)',
                    gridAutoRows: `repeact(1, 1fr)`,
                    gap: "3vh",
                    fontSize: "1.5vh",
                    fontWeight: "bold",
                    padding: "2vh",
                    borderRadius: "0.5vh",
                    border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                    backgroundColor: "rgba(12, 12, 12, 0.8)",
                    color: "rgba(200, 200, 200, 1)",
                }}
            >
                {hardmoneyData.propertyColors.map((colorStuff, index) => {
                    const isSelectedColor = colorStuff.colorNumber === hardmoneyData.houseColorNumber;
                    
                    return (
                        <div
                            key={index}
                            onClick={(e) => selectColor(e, colorStuff.colorNumber)}
                            style={{
                                width: "100%",
                                aspectRatio: "1/1",
                                height: "auto",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxSizing: "border-box",
                                backgroundColor: `${colorStuff.colorValue}`,
                                transition: "border 0.3s ease",
                                border: isSelectedColor ? "0.3vh solid white" : "0.2vh solid transparent",
                            }}
                        >
                            
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

export default ColorSettings;
